import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AiService {

  constructor(private httpClient: HttpClient) { }

  public generateSalaryRuleset(salaryRulesId: number, prompt: string, save: boolean): Observable<any> {
    return this.httpClient.post(`/api/ai/salary-ruleset`, { salary_rules_id: salaryRulesId, prompt: prompt, save: save })
  }

  public generateHolidays(prompt: string, save: boolean): Observable<any> {
    return this.httpClient.post(`/api/ai/holidays`, { prompt: prompt, save: save })
  }

  public translateAccountingPartner(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/accounting-partner`, { data: data, languages: environment.languages });
  }

  public translateAccountingProduct(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/accounting-product`, { data: data, languages: environment.languages });
  }

  public translateAccountingProductDocument(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/accounting-product-document`, { data: data, languages: environment.languages });
  }

  public translateAnnouncement(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/announcement`, { data: data, languages: environment.languages });
  }

  public translateAssignment(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/assignment`, { data: data, languages: environment.languages });
  }

  public translateArea(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/area`, { data: data, languages: environment.languages });
  }

  public translateBadge(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/badge`, { data: data, languages: environment.languages });
  }

  public translateCity(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/city`, { data: data, languages: environment.languages });
  }

  public translateOrganization(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/organization`, { data: data, languages: environment.languages });
  }
  
  public translateProduct(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/product`, { data: data, languages: environment.languages });
  }

  public translateUser(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/user`, { data: data, languages: environment.languages });
  }

  public translateMessageTemplate(data: {}, variables: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/message-template`, { data: data, variables: variables, languages: environment.languages });
  }

  public translatePrompt(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/prompt`, { data: data, languages: environment.languages });
  }

  public translateSkill(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/skill`, { data: data, languages: environment.languages });
  }

  public translateSkillGroup(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/skill-group`, { data: data, languages: environment.languages });
  }

  public assignmentFacebookPostGenerate(assignmentId: number, data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/assignments/${assignmentId}/facebook-post`, { ...data })
  }

  public assignmentFacebookPost(assignmentId: number, data: {}): Observable<any> {
    return this.httpClient.post(`/api/assignments/${assignmentId}/facebook-post`, { ...data })
  }

  public translateSalaryEstimate(data: {}): Observable<any> {
    return this.httpClient.post(`/api/ai/translate/salary-estimate`, { data: data, languages: environment.languages });
  }
}
